//mypreset.ts
import { definePreset, palette } from '@primeuix/themes';
import Material from '@primeuix/themes/material';




/*
semantic: {

    colorScheme: {
      light: {
          primary: {
              color: '{violet.900}',
              inverseColor: '#ffffff',
              hoverColor: '{violet.800}',
              activeColor: '{violet.600}'
          },
          highlight: {
              background: '{violet.800}',
              focusBackground: '{violet.600}',
              color: '#ffffff',
              focusColor: '#ffffff'
          }
      },
      dark: {
        root:
        {
          color:  '{purple.50}',
          background: '{purple.900}',
        },
          primary: {
              color: '{purple.500}',
              inverseColor: '{violet.900}',
              hoverColor: '{violet.400}',
              activeColor: '{violet.300}'
          },
          highlight: {
              background: 'rgba(250, 250, 250, 0.5)',
              focusBackground: 'rgba(250, 250, 250, .24)',
              color: 'rgba(255,255,255,.87)',
              focusColor: 'rgba(255,255,255,.87)'
          }
      }

  }
      */


// #8843: Tokens teils flach geschrieben (z. B. checkbox.disabled.background) – erzeugen dieselben CSS-Variablen
// wie die typisierten Pfade (geprüft in SortPreset.spec.ts), passen aber nicht zu den Typen von @primeuix/themes.
const Sortimentierenpreset = definePreset(Material, <any>{

  components: {

    progressspinner:
    {

      colorScheme: {
        light: {
          root: {
            color:
            {
              one: '{indigo.500}',
              two: '{indigo.500}',
              three: '{indigo.500}',
              four: '{indigo.500}'
            },
          },
        },
        dark: {
          root: {
            color:
            {
              one: '{indigo.200}',
              two: '{indigo.200}',
              three: '{indigo.200}',
              four: '{indigo.200}'
            },
          },
        }

      }

    },
    checkbox:
    {
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      root: {
        //#7863
        disabledBackground: '{slate.400}',
      }
    },

    dialog:
    {
      header:
      {
        padding: 'var(--paddingControlLarge)',
        gap: 'var(--gapControlSmall)',
      },
      // #8843: oben 0.5rem statt 0 (Material) - gleicht den negativen Rand einer PrimeFlex-.grid am Inhaltsanfang
      // aus, sonst wird der Inhalt 0.5rem zu hoch und bekommt einen Scrollbalken
      content:
      {
        padding: '0.5rem {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}',
      },
      css: ({ dt }) => `
              .p-dialog-header {
                  background: var(--p-surface-100);
              }
              `,



    },
    button:
    {
      root:
      {
        paddingX: 'var(--paddingControlMedium)',
        paddingY: 'var(--paddingControlMedium)',
      },
      // #9672: Primary-Buttons in Violett, aber mit Materials Stufen (hell 500/400/300 + weiß, dunkel 400/300/200 + dunkle Schrift)
      colorScheme: {
        light: {
          root: {
            primary: {
              background: '{violet.500}',
              hoverBackground: '{violet.400}',
              activeBackground: '{violet.300}',
              borderColor: '{violet.500}',
              hoverBorderColor: '{violet.400}',
              activeBorderColor: '{violet.300}',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
            }
          }
        },
        dark: {
          root: {
            primary: {
              background: '{violet.400}',
              hoverBackground: '{violet.300}',
              activeBackground: '{violet.200}',
              borderColor: '{violet.400}',
              hoverBorderColor: '{violet.300}',
              activeBorderColor: '{violet.200}',
              color: '{surface.900}',
              hoverColor: '{surface.900}',
              activeColor: '{surface.900}',
            }
          }
        }
      }
    },
    // #9672: Der gewählte Tab bekommt einen eigenen, helleren Hintergrund - Material lässt ihn transparent
    tabs: {
      colorScheme: {
        light: {
          tab: {
            activeBackground: '{violet.50}',
          }
        },
        dark: {
          tab: {
            activeBackground: '{slate.600}',
            activeColor: '{slate.50}',
          },
          // #9672: Inhalt der Tabs etwas dunkler als der übrige Inhalt (slate.900) - Mitte aus slate.900 und slate.950
          tabpanel: {
            background: 'color-mix(in srgb, {slate.900}, {slate.950})',
          }
        }
      }
    },
    inputgroup: {
      addon:
      {
        padding: 'var(--paddingControlSmall)',
      },
    },
    textarea: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
    },
    inputtext: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
        // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
        disabledBackground: 'var(--backgroundCommonContentDisabled)',
      },
    },
    autocomplete:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      disabled:
      {
        background: 'var(--backgroundCommonContentDisabled)'
      }
    },
    datepicker:
    {
      panel:
      {
        padding: 'var(--paddingControlSmall)',
      },
    },
    multiselect:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      option: {
        padding: 'var(--paddingControlSmall)',
      },
      list: {
        padding: 'var(--paddingControlSmall)',
        header: {
          padding: 'var(--paddingControlSmall)',
        }
      }
    },
    select: {


      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      option: {
        padding: 'var(--paddingControlSmall)',
      },
      list: {
        padding: 'var(--paddingControlSmall)',
        header: {
          padding: 'var(--paddingControlSmall)',
        }
      }
    },
    tree: {
      padding: 'var(--paddingControlSmall)',
      node: {
        padding: 'var(--paddingControltiny)',
      }
    },
    // #8843: Sortier-Icon der TreeTable wie unter PrimeNG 19 (1rem), eigener Token neben datatable
    treetable: {
      sortIcon: {
        size: '1rem',
      },
    },
    datatable:
    {

      // #8843: anders als im LiefPreset wirkt der Wert hier schon unter PrimeNG 19 (!important) – bleibt
      header:
      {
        cell:
        {
          padding: 'var(--paddingControlCell) !important',
        }
      },
      // #8843: Sortier-Icon wie unter PrimeNG 19 (p-icon 1rem, Textfarbe des Kopfes); PrimeNG 20 färbt es mit sortIcon.color
      sortIcon: {
        size: '1rem',
        color: '{text.color}',
      },
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      bodyCell: {
        padding: 'var(--paddingControlCell)',
      },
      css: ({ dt }) => `
              .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(odd):not(.p-datatable-row-selected) {
    .p-datatable-frozen-column
  {
      background: ${dt('datatable.row.striped.background')};
  }
}

.p-datatable-hoverable
  .p-datatable-tbody
  > tr:not(.p-datatable-row-selected):hover {
  .p-datatable-frozen-column {
    background: ${dt('datatable.row.hover.background')};
  }
}
                `,

      colorScheme: {
        light: {
          // datatable
          header:
          {
            cell: {
              // background: '{slate.100}',
            }
          },
          row: {
            // p-datatable-row-selected
            selected:
            {
                background: '{violet.300}',
            },
            striped: {
              background: '{slate.50}',
            }
          }
        },
        dark:
        {
          border:
          {
            color: '{slate.700}',
          },
          row: {
            background: '{slate.900}',
            color: '{slate.50}',
            hover:
            {
              background: '{violet.800}',
              color: '{slate.50}',
            }
          },
          body: {
            cell: {
              padding: 'var(--paddingControlCell)',
              border:
              {
                color: '{slate.700}'
              }
            }
          },
          // #9672: Tabellenkopf im Dark Mode "slate.750" (Mitte aus slate.700 und slate.800) mit weißer Schrift
          header:
          {
            background: 'color-mix(in srgb, {slate.700}, {slate.800})',
            color: '#ffffff',
            border:
            {
              color: '{slate.400}'
            },
            cell: {
              padding: 'var(--paddingControlCell)',
              hover:
              {
                background: '{violet.800}',
                color: '{slate.50}',
              },
              background: 'color-mix(in srgb, {slate.700}, {slate.800})',
              color: '#ffffff',
              border:
              {
                color: '{slate.700}'
              }
            }
          },
          footer:
          {
            background: '{slate.700}',
            color: '{slate.50}',
            cell: {
              padding: 'var(--paddingControlCell)',
              background: '{slate.700}',
              color: '{slate.50}',
              border:
              {
                color: '{slate.700}'
              }
            }
          }
        }
      }
    },
    paginator:
    {
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      root: {
        background: '{slate.50}'
      },
      // #9672: slate.50 galt auch im Dark Mode - die nicht gewählten Seiten (slate.400) waren darauf kaum zu sehen
      colorScheme: {
        dark: {
          root: {
            background: '{slate.800}'
          },
          navButton: {
            color: '{slate.200}',
            hoverColor: '{slate.50}'
          }
        }
      }
    },
    panel:
    {
      header: {
        background: '{slate.50}',
        padding: 'var(--paddingControlSmall)',
      },
      // #9672: slate.50 galt auch im Dark Mode - der Kopf war dort fast weiß; jetzt "slate.750" (Mitte aus slate.700 und slate.800) mit weißer Schrift
      colorScheme: {
        dark: {
          header: {
            background: 'color-mix(in srgb, {slate.700}, {slate.800})',
            color: '#ffffff',
          }
        }
      }
    },
    toolbar:
    {
      root: {
        padding: 'var(--paddingControlSmall)',
        gap: 'var(--gapControlSmall)',
      },
      background: '{slate.100}',
    },
    menubar:
    {
      // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
      root: {
        background: '{slate.100}',
      },
      submenu:
      {
        background: '{slate.50}',
      },
      // #9672: slate.100/slate.50 galten auch im Dark Mode
      colorScheme: {
        dark: {
          root: {
            background: '{slate.800}',
          },
          submenu: {
            background: '{slate.800}',
          }
        }
      }
    },

    accordion:
    {
      header: {
        background: '{slate.100}',
        hover:
        {
          background: '{slate.200}',
        },
        active:
        {
          background: '{slate.100}',
          hover:
          {
            // background: '{slate.200}',
          },
        }
      },
      // #9672: slate.100/slate.200 galten auch im Dark Mode
      colorScheme: {
        dark: {
          header: {
            background: '{slate.800}',
            hoverBackground: '{slate.700}',
            activeBackground: '{slate.800}',
          }
        }
      }
    },
    togglebutton: {
      colorScheme: {
        light: {
          root: {
            // #8843: Material-Pfad – der flache Pfad erzeugt dieselbe Variable, unter PrimeNG 20 gewinnt aber der Basiswert
            checkedBackground: '{indigo.100}',
          },
          background: '{surface.200}',
          border: {
            color: '{indigo.600}'
          },
          checked:
          {
            border: {
              color: '{indigo.300}'
            }
          }
        },
        dark: {

          background: '{slate.700}',
          color: '{indigo.50}',
          icon: {
            color: '{slate.50}',
            checked:
            {
              color: '{slate.50}',
            },
            hover:
            {
              color: '{indigo.200}',
            }
          },
          hover:
          {
            color: '{indigo.50}',
            background: '{slate.700}',
          },
          checked:
          {
            color: '{indigo.300}',
            background: '{slate.700}'
          }
        }
      },
    }
  },
  semantic: {

    colorScheme: {
      light: {
        primary: palette('{violet}'),
        highlight: {
          background: '{violet.800}',
          focusBackground: '{violet.600}',
          color: '#ffffff',
          focusColor: '#ffffff'
        }

      },
      dark: {

        autocomplete:
        {
          background: '{slate.800}',
          color: '{slate.50}',
          option:
          {
            background: '{slate.700}',
            color: '{slate.50}',
            border: {
              color: '{slate.500}',
            },
            focus:
            {
              background: '{slate.800}',
              color: '{indigo.50}',
            }
          },
          overlay:
          {
            background: '{slate.800}',
            color: '{slate.50}',
            border: {
              color: '{slate.500}',
            },
            content:
            {
              background: '{slate.700}',
              color: '{slate.50}',
            }
          },
          empty:
          {
            message: {
              background: '{zinc.800}',
            }
          }
        },
        popover:
        {
          background: '{zinc.800}',
          border:
          {
            color: '{slate.500}'
          },
          content:
          {

          }
        },
        inputgroup:
        {
          background: '{slate.900}',
          color: '{slate.50}',
          addon:
          {
            background: '{zinc.800}',
            border:
            {
              color: '{slate.800}',
            }
          }
        },
        formField: {
          hoverBorderColor: '{primary.color}',
          color: '{slate.50}',
          background: '{slate.900}',
        },

        text: {

        },

        components: {

          formgroup:
          {
            background: '{slate.800}',
            color: '{slate.50}',
          },
          form: {
            field: {
              hoverBorderColor: '{primary.color}',
              color: '{slate.50}',
              background: '{slate.900}',
            }
          },

          inputgroup:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          splitter:
          {
            background: '{slate.800}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.800}',
            }
          },
          tabs:
          {
            tab:
            {
              color: '{slate.950}',
              background: '{slate.500}'
            },
            tablist: {
              color: '{slate.50}',
              background: '{slate.700}'
            },
            tabpanel:
            {
              color: '{slate.50}',
              background: '{slate.700}'
            }
          },
          fileupload:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          treeselect:
          {
            background: '{slate.900}',
            color: '{slate.50}',

          },
          tree:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            node: {
              hover: {
                background: '{slate.500}',
              },
              background: '{slate.900}',
              color: '{slate.50}',
              content: {
                background: '{slate.900}',
                color: '{slate.50}',

              }
            }
          },
          inputnumber:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            placeholder:
            {
              color: '{slate.300}',
            }
          },
          inputtext:
          {
            background: '{slate.900}',

            color: '{slate.50}',
            placeholder:
            {
              background: '{slate.800}',
              color: '{slate.300}',
            },
            disabled:
            {
              color: '{slate.100}',
            }
          },
          paginator:
          {
            background: '{slate.700}',
            color: '{surface.0}',
            nav: {
              button: {
                background: '{slate.700}',
                hover: {
                  background: '{slate.500}',
                }
              }
            },
            current:
            {
              nav: {
                button: {
                  color: '{slate.50}',
                  background: '{slate.500}',
                  hover: {

                  }

                }
              },
              page:
              {
                report: {
                  color: '{slate.50}'
                }
              }
            }



          },
          datepicker:
          {
            color: '{surface.50}',
            header:
            {
              background: '{slate.300}',

            },
            day: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            month: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            year: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            dropdown:
            {
              background: '{slate.700}',
              color: '{surface.50}',
              active:
              {
                background: '{zinc.500}',
                color: '{zinc.50}',
              }
            }

          },
          textarea:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },





          select:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            Overlay:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            placeholder:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
            },
            option:
            {
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              background: '{slate.900}',
              selected:
              {
                background: '{slate.800}',

              }
            }


          },
          multiselect:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            label:
            {
              background: '{slate.900}',
              color: '{slate.50}'
            },
            placeholder:
            {
              color: '{slate.100}',
              background: '{slate.900}',
            },
            Overlay:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              hover:
              {
                background: '{slate.500}',
              }
            },
            option:
            {
              background: '{slate.900}',
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              selected:
              {
                background: '{slate.800}',
              }
            }

          },
          dialog:
          {
            background: '{zinc.600}',
            color: '{zinc.50}',
            border:
            {
              color: '{zinc.700}',
            },
            css: ({ dt }) => `
              .p-dialog-header {
                  background: var(--p-surface-600);
              }
              `
          },
          treetable:
          {
            body: {
              cell:
              {
                padding: 'var(--paddingControlCell)',
                background: '{zinc.700}',
                color: '{zinc.50}',
                border: {
                  color: '{slate.500}',
                },
                hover:
                {
                  background: '{zinc.200}',
                  color: '{zinc.900}',
                }
              }
            },
            row:
            {
              background: '{zinc.700}',
              color: '{zinc.50}',
              hover:
              {
                background: '{zinc.200}',
                color: '{zinc.900}',
              }
            },
            header: {
              background: '{zinc.700}',
              color: '{zinc.50}',
              cell:
              {
                padding: 'var(--paddingControlCell)',
                background: '{zinc.700}',
                color: '{zinc.50}'
              }
            }
          },

          checkbox:
          {
            background: '{zinc.400}',
          },
          radiobutton:
          {
            background: '{zinc.400}',
          },

          toolbar:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.700}',
            },
          },
          menubar:
          {
            border:
            {
              color: '{slate.700}',
            },
            background: '{slate.900}',
            color: '{slate.50}',
            label:
            {
              background: '{slate.700}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.50}',
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              label:
              {
                background: '{slate.700}',
                color: '{slate.50}',
              }
            },
            submenu:
            {
              background: '{slate.900}',
              border:
              {
                color: '{slate.700}',
              },
              color: '{slate.50}',
              list:
              {
                background: '{slate.900}',
                color: '{slate.50}',
                border:
                {
                  color: '{slate.700}',
                },
              }
            }
          },
          panel:
          {
            background: '{slate.700}',
            color: '{slate.100}',

            border: {
              color: '{slate.700}'
            },
            header:
            {
              background: '{slate.700}',
              color: '{slate.100}',
              border: {
                color: '{slate.700}'
              }
            }
          },
          button: {

          },
          accordion:
          {
            header: {
              color: '{slate.100}',
              background: '{slate.800}',
              hover:
              {
                color: '{slate.100}',
                background: '{slate.600}',
              },
              active:
              {
                color: '{slate.100}',
                background: '{slate .700}',
                hover:
                {
                  color: '{slate.100}',
                  background: '{slate.500}',
                },
              }

            },
            content: {
              color: '{slate.50}',
              background: '{slate.900}'
            }
          },
        },
        navigation: {
          list: {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          item: {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          submenuLabel: {
            background: '{slate.800}',
            color: '{slate.50}',
          },
          submenuIcon: {
            background: '{slate.700}',
            color: '{slate.50}',
            hover:
            {
              color: '{indigo.50}',
            }
          }
        },

        root: {
          editBackground: '{green.950}',
          background: '{surface.950}',
          hoverBackground: '{surface.800}',
          borderColor: '{surface.900}',
          color: '{surface.50}',
          hoverColor: '{surface.500}',
          checkedColor: '{surface.0}',
          checkedBorderColor: '{surface.800}',

        },
        primary: palette('{indigo}'),
        // #9672: kein eigenes highlight mehr - fokussiert war es halbtransparentes Weiß (0.5), gewählte Einträge in
        // Listen (z. B. Zeilen pro Seite im Paginator) waren darauf kaum lesbar; jetzt Materials Standard
        surface: {
          0: 'rgba(255,255,255,.87)',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}'
        },
      }

    }
  }



});



export default Sortimentierenpreset;


